import React from 'react';
import PropTypes from 'prop-types';

import { useSelector, useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { removeFeatureFromLandAssemblyAsync } from '../../../../redux/land_assembly/Actions';

const useStyles = makeStyles((theme) => style(theme));

const propTypes = {

};

const defaultProps = {

};

function LandAssemblyFeatureItem ({ layer, feature }) {
    const classes = useStyles();

    const dispatch = useDispatch();
    const dispatchRemoveFeatureFromLandAssembly = (featureId) => dispatch(removeFeatureFromLandAssemblyAsync(featureId));

    // TODO - NOT HARD CODED
    const proprietorName = feature.properties['proprietorship_name'] || 'Private';
    const title = feature.properties[layer?.properties?.label];
    const subheader = proprietorName + ' ' + (feature.properties['categories_aggregate'] || '');

    function handleRemove () {
        dispatchRemoveFeatureFromLandAssembly(feature);
    }

    return (<Card classes={{ root: classes.root }} variant="outlined">
        <CardHeader
            title={title}
            subheader={subheader}
            action={
                <IconButton size="small" onClick={handleRemove}>
                    <CloseIcon color="error" />
                </IconButton>
            }
            titleTypographyProps={{ color:'textPrimary' }}
            subheaderTypographyProps={{ color:'textPrimary' }}
        />
    </Card>);
}

LandAssemblyFeatureItem.propTypes = propTypes;
LandAssemblyFeatureItem.defaultProps = defaultProps;

const style = theme => ({
    root: {
        // display: 'flex',
        // alignItems: 'center',
        // borderRadius: 5,
        // border: `1px solid ${theme.palette.background.border}`,
        // padding: 10,
        '&:hover': {
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: `0px 0px 0px 1px ${theme.palette.secondary.light} inset`
        }
    }
});

export default LandAssemblyFeatureItem;